<template>
  <van-collapse v-model="activeName" accordion class="productmatrix">
    <van-collapse-item
      title="BOD决策引擎"
      name="1"
      class="productmatrix-item"
      :class="{ 'productmatrix-item-check': activeName == '1' }"
    >
      <div class="info">
        <p>
          BOD平台脱胎于专家系统，是华院计算自主打造的一款智能决策平台，其汇集专家规则/策略/经验、AI技术算法/模型/成果，形成新一代的智能决策平台，在信创浪潮中为银行、保险、政务、制造等行业持续创造高效决策的价值。
        </p>
        <p>
          <strong>在银行业，</strong
          >BOD广泛应用于大行对公、零售的授信和额度管理，交易/贸易的风险拦截，操作风险相关风险的识别，全面风险内评，以及全行级的智能风控等领域，并在大行逐步替代IBM
          ilog、Exparian、SDS等国外品牌的规则引擎产品，成为国产化的一支重要力量。
        </p>
        <p>
          <strong>在保险业，</strong
          >BOD应用于反欺诈、保单稽核、业务营销规则推荐等场景。
        </p>
        <p>
          <strong>在政务领域，</strong>
          BOD应用于组织人员评价、应急事件预警、准入事件稽核、甚至偷渡/电诈风险识别。
        </p>
        <p>
          截止目前，BOD已经为建设银行、进出口银行、国家开发银行等数十家银行和机构提供了服务；每天，数以亿计的决策结果由BOD输出并得到应用，BOD秉承“赋能企业数据智能”的使命，越来越深刻地影响到企业经营的方方面面。
        </p>
      </div>
      <img :src="product_finance_BOD" alt="BOD" class="productmatrix-img" />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.bod"
          :key="`productmatrix-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span
            ><strong>{{ item.item }}</strong
            >{{ item.text }}</span
          >
        </div>
      </div>
    </van-collapse-item>
    <!-- <van-collapse-item title="小微信贷IPC线上化" name="2" class="productmatrix-item" :class="{'productmatrix-item-check': activeName == '2'}">
        <div class="info">
          针对银行小企业风控痛点：如何解决客户经理小企业财务尽调真实性？如何标准化小企业信贷管理模型？如何有效线上贷后监控？华院提出小微信贷IPC线上化解决方案：以风控产品为触点，标准化小企业额度审批模型和评级模型，标准化线上风控流程，实现有效贷后监控和管理。
        </div>
        <img :src="product_finance_IPC" alt="IPC" class="productmatrix-img">
        <div class="superiority">
          <div class="title">产品价值</div>
          <div class="superiority-item" v-for="(item, index) in advantageList.ipc" :key="`productmatrix-item2-superiority${index + 1}`">
            <img :src="product_society_superiority" alt="重要性标志">
            <span><strong>{{item.item}}</strong>{{item.text}}</span>
          </div>
        </div>
      </van-collapse-item> -->
  </van-collapse>
</template>
<script>
import product_finance_BOD from "@/../static/img/product/product_finance_BOD.svg";
import product_finance_IPC from "@/../static/img/product/product_finance_IPC.svg";
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
export default {
  data() {
    return {
      product_finance_BOD,
      product_finance_IPC,
      product_society_superiority,
      activeName: "1",
      advantageList: {
        bod: [
          {
            item: "自主可控：",
            text:
              "拥有规则引擎核心专利算法（发明专利，专利号：ZL202110918672.0），全面掌握产品核心技术，系统从研发、升级、维护全程可控"
          },
          {
            item: "高度集成：",
            text:
              "包含变量平台、规则引擎、监控中心、预警中心、任务管理、流计算等多个模块，满足客户多层次的需求"
          },
          { item: "业务经验：", text: "与银行新核心的组件深度集成" },
          {
            item: "集成知识：",
            text:
              "无缝承载超过600套风控策略资产，对相关策略建设和运行的方式有深刻理解"
          },
          {
            item: "技术优势：",
            text:
              "规则引擎使用自研顺序算法，大量的工程化优化使得单机服务性能卓越，集群平行扩展支持千万级别的业务并发"
          },
          {
            item: "纯界面交互：",
            text:
              "实现对业务规则的界面化配置实现和灵活便捷调整，支持业务人员最快1分钟调整策略，快速响应市场变化"
          },
          {
            item: "高灵活配置：",
            text:
              "独特、丰富而克制的组件设计，支持复杂策略的配置；支持灵活的规则"
          },
          {
            item: "高度可复用：",
            text:
              "支持引擎内策略复用，具备高可扩展性和维护性；无缝兼容IBMilog策略、SMG3策略、计划兼容Blaze"
          }
        ],
        ipc: [
          {
            item: "方案成熟久经验证：",
            text:
              "方案成熟且经过实践检验（产品、风控、模型、系统、数据等），可以结合银行自身特点做调整，开发时间周期短。有个人征信解析、企业征信解析、税票解析变量、成熟策略模型"
          },
          {
            item: "核心数据快速接入：",
            text:
              "发票数据有现成的解决方案，前期费用不高，根据使用量支付费用。有税票变量、税票报告产品，同时定制化为行方搭建区域行业产品的分析，并提供交叉检验方案"
          },
          {
            item: "特有风控能力支撑：",
            text:
              "针对风控较弱的小城商行，提供整套IPC尽调培训，并辅助线上化转型"
          },
          {
            item: "提供增值获客服务：",
            text: "通过华院线下的流量入口，向银行提供获客服务（与花呗借呗合作）"
          }
        ]
      }
    };
  }
};
</script>
<style lang="less" scoped>
.productmatrix {
  width: 100%;

  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }

  /deep/ .van-cell__right-icon {
    display: none;
  }

  .productmatrix-item {
    padding: 0 64px;
    background: #ffffff;

    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }

  .productmatrix-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }

  .productmatrix-img {
    width: 100%;
    margin: 44px 0;
  }

  .superiority {
    margin-bottom: 32px;

    .title {
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }

    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin-bottom: 32px;

      > img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/finance/productmatrix.vue